<div role="contentinfo">
    @if (data?.stats?.length > 0) {
        <div echarts
             [loading]="isLoading()"
             [options]="chartOption"
             [loadingOpts]="loadingOptions" class="chart"></div>
    } @else {
        <mat-card appearance="outlined" class="m-10 align-items-center">
            <mat-card-content>
                <strong>Info:</strong> No data available.
            </mat-card-content>
        </mat-card>
    }
</div>
